"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.sort");

var _sendAddress = require("@/api/cms/sendAddress");

var _AddressCascader = _interopRequireDefault(require("@/views/cms/common/AddressCascader"));

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

var _default = {
  name: 'AddressSelector',
  components: {
    AddressCascader: _AddressCascader.default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // 当前收货信息，用于匹配已选地址
    currentReceivePerson: {
      type: String,
      default: ''
    },
    currentReceivePhone: {
      type: String,
      default: ''
    },
    currentReceiveAddress: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      addressList: [],
      addressLoading: false,
      selectedAddressId: null,
      addressAddVisible: false,
      addressAddLoading: false,
      editAddressId: null,
      addressAddForm: {
        name: '',
        phone: '',
        address: '',
        detailedAddress: '',
        isDefault: 0
      }
    };
  },
  computed: {
    visible: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.selectedAddressId = null;
    },
    loadAddressList: function loadAddressList(callback) {
      var _this = this;

      this.addressLoading = true;
      (0, _sendAddress.getSendAddressList)({
        page: 0,
        size: 100
      }).then(function (response) {
        if (response.code === 200) {
          var list = response.data.content || [];
          _this.addressList = list.filter(function (a) {
            return a.enabled !== false;
          }).sort(function (a, b) {
            return (b.isDefault || 0) - (a.isDefault || 0);
          });
        }
      }).finally(function () {
        _this.addressLoading = false;
        if (typeof callback === 'function') callback();
      });
    },
    matchCurrentAddress: function matchCurrentAddress() {
      if (!this.currentReceivePerson && !this.currentReceivePhone && !this.currentReceiveAddress) return;

      var _iterator = _createForOfIteratorHelper(this.addressList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var addr = _step.value;
          var region = this.fmtAddress(addr.address || '');
          var detail = addr.detailedAddress || '';
          var fullAddr = detail ? "".concat(region, " ").concat(detail) : region;

          if (addr.name === this.currentReceivePerson && addr.phone === this.currentReceivePhone && fullAddr === this.currentReceiveAddress) {
            this.selectedAddressId = addr.id;
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    confirmSelection: function confirmSelection() {
      var _this2 = this;

      var addr = this.addressList.find(function (a) {
        return a.id === _this2.selectedAddressId;
      });

      if (addr) {
        var region = this.fmtAddress(addr.address || '');
        var detail = addr.detailedAddress || '';
        this.$emit('select', {
          receivePerson: addr.name || '',
          receivePhone: addr.phone || '',
          receiveAddress: detail ? "".concat(region, " ").concat(detail) : region,
          custAddress: addr.detailedAddress || addr.address || ''
        });
      }

      this.visible = false;
    },
    fmtAddress: function fmtAddress(val) {
      if (!val) return '';
      return val.replace(/\//g, ' ');
    },
    openAddressAdd: function openAddressAdd() {
      this.editAddressId = null;
      this.addressAddForm = {
        name: '',
        phone: '',
        address: '',
        detailedAddress: '',
        isDefault: 0
      };
      this.addressAddVisible = true;
    },
    editAddress: function editAddress(addr) {
      this.editAddressId = addr.id;
      this.addressAddForm = {
        name: addr.name || '',
        phone: addr.phone || '',
        address: addr.address || '',
        detailedAddress: addr.detailedAddress || '',
        isDefault: addr.isDefault || 0
      };
      this.addressAddVisible = true;
    },
    submitAddressAdd: function submitAddressAdd() {
      var _this3 = this;

      if (!this.addressAddForm.name || !this.addressAddForm.phone || !this.addressAddForm.address) {
        this.$message.warning('请填写联系人、联系电话和所在地区');
        return;
      }

      this.addressAddLoading = true;
      var action = this.editAddressId ? (0, _sendAddress.updateSendAddress)(_objectSpread({
        id: this.editAddressId
      }, this.addressAddForm)) : (0, _sendAddress.addSendAddress)(this.addressAddForm);
      action.then(function (response) {
        if (response.code === 200) {
          _this3.$message.success(_this3.editAddressId ? '地址编辑成功' : '地址添加成功');

          _this3.addressAddVisible = false;
          _this3.editAddressId = null;

          _this3.loadAddressList();
        } else {
          _this3.$message.error(response.message || '操作失败');
        }
      }).finally(function () {
        _this3.addressAddLoading = false;
      });
    },
    deleteAddressItem: function deleteAddressItem(id) {
      var _this4 = this;

      this.$confirm('确定要删除该地址吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _sendAddress.deleteSendAddress)(id).then(function (response) {
          if (response.code === 200) {
            _this4.$message.success('删除成功');

            if (_this4.selectedAddressId === id) {
              _this4.selectedAddressId = null;
            }

            _this4.loadAddressList();
          } else {
            _this4.$message.error(response.message || '删除失败');
          }
        });
      }).catch(function () {});
    }
  },
  watch: {
    visible: function visible(val) {
      var _this5 = this;

      if (val) {
        this.addressList = [];
        this.selectedAddressId = null;
        this.loadAddressList(function () {
          _this5.matchCurrentAddress();
        });
      }
    }
  }
};
exports.default = _default;